import { adminRoutesURLs } from '../../../constants/routes';

type SidebarNavigationType = {
  name: string;
  url: string;
};

// todo Hiding Analitycs and Reports
const {
  branches,
  sectionServices,
  workplaces,
  employers,
  audit,
  userArea,
  terminalAppearance,
  tabloSettings,
  ratingSettings,
  misSettings,
  queueScenarioSettings
} = adminRoutesURLs;

// const { sectionServices, workplaces, employers, parkingSlots, userArea } = adminRoutesURLs;

// Переменные роутов для аналитики и отчетов
const {
  analyticsAndReportsBase,
  services,
  employersReports,
  visitors,
  currentServicesStatus,
  qualityReport
} = adminRoutesURLs.analyticsAndReports;

export const SidebarNavigation: SidebarNavigationType[] = [
  {
    name: 'Филиалы',
    url: branches
  },
  {
    name: 'Категории и услуги',
    url: sectionServices
  },
  {
    name: 'Сотрудники',
    url: employers
  },
  {
    name: 'Рабочие места',
    url: workplaces
  },
  {
    name: 'Аудит',
    url: audit
  },
  {
    name: 'Аналитика и отчеты',
    url: `${analyticsAndReportsBase}/${currentServicesStatus}`
  },
  {
    name: 'Настройки',
    url: terminalAppearance
  },
  {
    name: 'Личный кабинет',
    url: userArea
  }
];
export const AnalyticsAndReportsNavigation: SidebarNavigationType[] = [
  {
    name: 'Текущее состояние обслуживания посетителей',
    url: currentServicesStatus
  },
  {
    name: 'По услугам',
    url: services
  },
  {
    name: 'По сотрудникам',
    url: employersReports
  },
  {
    name: 'По посетителям',
    url: visitors
  },
  {
    name: 'Оценка качества обслуживания',
    url: qualityReport
  }
];
export const SettingsNavigation: SidebarNavigationType[] = [
  {
    name: 'Терминал',
    url: terminalAppearance
  },
  {
    name: 'Табло',
    url: tabloSettings
  },
  {
    name: 'Оценка качества',
    url: ratingSettings
  },
  {
    name: 'МИС и льготы',
    url: misSettings
  },
  {
    name: 'Сценарий очереди',
    url: queueScenarioSettings
  }
];
